export default function registrationNumberPresentation(registrationNumber: string): string {
  let presentation = ''
  if (registrationNumber) {
    presentation = registrationNumber.slice(0, 3) + ' ' + registrationNumber.slice(3)
  }
  return presentation
}
